<template>
  <div class="BoxProcedimento">
    <div class="BoxProcedimento_header">
      {{ getLabelAcao(propProcedimento.acao) }}
    </div>
    <div class="BoxProcedimento_content d-flex align-items-center justify-content-between p-2">
      <div v-if="propProcedimento.acao == 'ALTERACAO_ESTADO_CIVIL'"
           class="col-2">
        <div class="BoxProcedimento_content_header">
          Motivo
        </div>
        <div class="BoxProcedimento_content_text">
          {{ getLabelMotivo(propProcedimento.motivo) }}
        </div>
      </div>
      <div class="col-2">
        <div class="BoxProcedimento_content_header">
          Origem
        </div>
        <div class="BoxProcedimento_content_text">
          {{ getLabelOrigem(propProcedimento.origem) }}
        </div>
      </div>
      <div v-if="propProcedimento.data_escritura"
           class="col-2">
        <div class="BoxProcedimento_content_header">
          Data da Escritura
        </div>
        <div class="BoxProcedimento_content_text">
          {{ propProcedimento.data_escritura | date }}
        </div>
      </div>
      <div v-if="propProcedimento.data_mandado"
           class="col-2">
        <div class="BoxProcedimento_content_header">
          Data do Mandado
        </div>
        <div class="BoxProcedimento_content_text">
          {{ propProcedimento.data_mandado | date }}
        </div>
      </div>
      <div class="col-3">
        <div class="BoxProcedimento_content_header">
          Data da solicitação
        </div>
        <div v-if="propProcedimento.data_averbacao"
             class="BoxProcedimento_content_text">
          {{ propProcedimento.data_averbacao | date }}
        </div>
        <div v-else>
          Não informado
        </div>
      </div>
      <div class="col-2" />
      <div>
        <b-dropdown size="sm"
                    right
                    split
                    text="Ver detalhes"
                    @click="showModal()">
          <b-dropdown-item @click="showModal()">
            Ver detalhes
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="editarProcedimento(propProcedimento)">
            Editar
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="excluirProcedimento">
            Excluir
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <ProcedimentoDetalhes v-if="showDetalhes"
                          :prop-procedimento="propProcedimento"
                          @hide="showDetalhes = false"
                          @editar="editarProcedimento" />
  </div>
</template>

<script>
  import ProcedimentoDetalhes from '@/components/SofiaRei/Casamento/ProcedimentosDetalhes.vue'
  import ProcedimentoService from "@/services/ProcedimentoService"

  export default {
    name: 'BoxProcedimento',
    components: {
      ProcedimentoDetalhes
    },
    props: {
      propProcedimento: { type: Object, default: () => ({})}
    },
    data () {
      return {
        acoes: [
          { label: 'Alteração de Estado Civil', value: 'ALTERACAO_ESTADO_CIVIL' },
          { label: 'Inteiro Teor', value: 'INTEIRO_TEOR'}
        ],
        tiposAlteracao: [
          { label: 'Divórcio', value: 'DIVORCIO', origens: ['ESCRITURA', 'MANDADO'] },
          { label: 'Separação', value: 'SEPARACAO', origens: ['ESCRITURA', 'MANDADO'] },
          { label: 'Reconciliação', value: 'RECONCILIACAO', origens: ['ESCRITURA', 'MANDADO'] },
          { label: 'Desquite', value: 'DESQUITE', origens: ['MANDADO'] },
          { label: 'Anulação', value: 'ANULACAO', origens: ['MANDADO'] },
        ],
        origens: [
          { label: 'Mandado Judicial', value: 'MANDADO' },
          { label: 'Escritura', value: 'ESCRITURA'},
          { label: 'Digitado', value: 'DIGITADO'}
        ],
        showDetalhes: false
      }
    },
    methods: {
      getLabelMotivo (motivo) {
        const tipoAlteracao = this.tiposAlteracao.find(tipo => tipo.value === motivo)

        if (tipoAlteracao) {
          return tipoAlteracao.label
        }

        return 'Não Informado'
      },
      getLabelAcao (acao) {
        const tipoAcao = this.acoes.find(action => action.value === acao)

        if (tipoAcao) {
          return tipoAcao.label
        }

        return 'Não Informado'
      },
      getLabelOrigem (origem) {
        const origin = this.origens.find(origin => origin.value === origem)

        if (origin) {
          return origin.label
        }

        return 'Não Informado'
      },
      showModal () {
        this.showDetalhes = true
      },
      async editarProcedimento (procedimento) {
        await this.getDocumentos()

        this.$emit('editarProcedimento', procedimento)
        
        this.showDetalhes = false
      },
      async getDocumentos () {
        if (!this.propProcedimento.procedimentoArquivo.length) return

        try {
          loader({ active: true, text: 'Buscando dados...'})

          const documentos = await ProcedimentoService.getDocumentos(this.propProcedimento.procedimento_id)

          if (documentos && documentos.length) {
            const imagens = []

            for (const documento of documentos) {
              const res = await ProcedimentoService.getPDF(documento.url)

              if (res) {
                this.propProcedimento.procedimentoArquivo.forEach(arq => {
                  if (arq.procedimento_arquivo_id === documento.procedimento_arquivo_id) {
                    arq.pdf = res
                  }
                })

                imagens.push(res)
              }
            }
          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ active: false, text: ''})
        }
      },
      async excluirProcedimento () {
        const res = await displayMessage('question', 'Alerta!', 'Tem certeza que deseja excluir esse procedimento?')

        if (res.value) {
          this.$emit('excluirProcedimento', this.propProcedimento.procedimento_id)
        }
      }
    }
  }
</script>

<style lang="scss">
.BoxProcedimento {
  box-shadow: 0 0 10px 0 #c6c6c6;

  &_header {
    background: #01AEC9;
    color: #101010;
    font-weight: bold;
    padding: 10px 20px;
  }

  &_content {
    &_header {
      font-size: 18px;
      font-weight: bold;
    }

    &_text {
      font-size: 16px;
      font-weight: 400;
    }
  }
}

</style>